export const OFLC_SEND_INVITATION = "OFLC_SEND_INVITATION";
export const OFLC_SEND_INVITATION_SUCCESS = "OFLC_SEND_INVITATION_SUCCESS";
export const OFLC_SEND_INVITATION_FAILED = "OFLC_SEND_INVITATION_FAILED";

export function sendInvitation(payload) {
  return {
    type: OFLC_SEND_INVITATION,
    payload,
  };
}

export function sendInvitationSuccess(payload) {
  return {
    type: OFLC_SEND_INVITATION_SUCCESS,
    payload: payload,
  };
}

export function sendInvitationFail(payload) {
  return {
    type: OFLC_SEND_INVITATION_FAILED,
    payload: payload,
  };
}
